import React, {useContext, useRef} from "react";
import { createPopper } from "@popperjs/core";
import {Link} from "react-router-dom";
import {closeSession} from "../../api/auth.service";
import {types} from "../../shared/types/types";
import {UseLoader} from "../../hooks/useLoader";
import { Toast } from 'primereact/toast';
import {AppContext} from "../../context/appContext";


const NotificationDropdown = () => {
  // dropdown props
    const [handleLoader] = UseLoader();
    const { dispatch} = useContext(AppContext);
    const toast = useRef(null);
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "left-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

    const cerrarSesion = async () => {
        try {
            handleLoader(true);
            const response = await closeSession();
            handleLoader(false);
            const resposeData = await response.data;

            if (resposeData.estado !== 200) {
                toast.current?.show({severity:'danger', summary: 'Alerta', detail: resposeData.mensaje, life: 3000});
                return;
            }
            const action = {
                type: types.logout
            }
            toast.current?.show({severity:'success', summary: 'Hasta la próxima', detail: resposeData.mensaje, life: 2000});
            dispatch(action);
        }catch (e) {
            handleLoader(false);
            console.log(e);
        }
    }
  return (
    <>
        <Toast ref={toast} />
      <a
        className="text-blueGray-500 py-1 px-3"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
          <Link
              className={
                  "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
              }
              to="/profile"
          >
              Perfil

          </Link>

          <div className="h-0 my-2 border border-solid border-blueGray-100"/>
          <button
              className={
                  "text-left focus:outline-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
              }
              onClick={async (e) =>  {
                  e.preventDefault();
                  await cerrarSesion();
              }}
          >
              Cerrar sesión
          </button>

      </div>
    </>
  );
};

export default NotificationDropdown;
